import React, { useCallback, useContext, useRef } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { usePopover } from '../../../../Popovers/redux/hooks';
import { PopoverType } from '../../../../Popovers/redux/types';
import AddToGroupPopover from '../../../_partials/AddToGroupPopup';
import AddToGroupButton, {
  Props as AddToGroupButtonProps,
} from '../AddToGroupButton';
import PositionOnlyPopperPopover from '@wix/da-ds/pkg/popper/presets/PositionOnlyPopperPopover';
import type { OffsetModifier } from '@wix/da-ds/pkg/popper/types';

const offsetModifier: OffsetModifier = [0, 20];

const AddToGroupButtonWithPopover: React.FC<AddToGroupButtonProps> = ({
  deviation,
  actionBarType,
}) => {
  const isMobile = useContext(MobileContext);
  const toggleRef = useRef<HTMLDivElement | null>(null);

  const { popover, pushPopover, removePopover } = usePopover(
    actionBarType === 'primary'
      ? PopoverType.ADD_TO_GROUP_PRIMARY
      : PopoverType.ADD_TO_GROUP_SECONDARY
  );

  const togglePopover = useCallback(() => {
    if (popover.isOpen) {
      removePopover();
    } else {
      pushPopover();
    }
  }, [popover.isOpen, pushPopover, removePopover]);

  const handleOnClickOutside = useCallback(
    (e: MouseEvent) => {
      if (
        (toggleRef.current && toggleRef.current.contains(e.target as Node)) ||
        isMobile
      ) {
        return;
      }
      removePopover();
    },
    [removePopover, isMobile]
  );

  return (
    <PositionOnlyPopperPopover
      ref={toggleRef}
      popoverContent={
        <AddToGroupPopover
          actionbarType={actionBarType}
          deviation={deviation}
          onClose={removePopover}
        />
      }
      isVisible={popover.isOpen}
      placement="bottom"
      offsetModifier={offsetModifier}
      onClickOutside={handleOnClickOutside}
    >
      <AddToGroupButton
        activated={popover.isOpen}
        deviation={deviation}
        onClick={togglePopover}
        withTooltip={!popover.isOpen}
      />
    </PositionOnlyPopperPopover>
  );
};
AddToGroupButtonWithPopover.displayName = 'AddToGroupButtonWithPopover';

export default AddToGroupButtonWithPopover;
